import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
export const getMasterColumns = (editTopicType, deleteTopicType) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      //sort: true,

      // events: onClickCol,
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editTopicType(row);
              }}
            />
            <DeleteIcon
             color="action"
              onClick={() => {
                deleteTopicType(row.TOPIC_ID);
              }}
            />
          </Box>
        );
      },
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "TOPIC_ID",
      text: "Topic ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "LOAD_TOPIC",
      text: "Load Topic",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "ACTIVE",
      text: "Active",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
  ];
  return columns;
};
